import { SOCIAL_POST_TYPES } from "../consts/socialPostType.constant";
import { SocialPost } from "../interfaces/api/get-social-posts";
import { PostVideo } from "../interfaces/postVideo";

/**
 * True si el compositor tiene video listo (misma idea que MediaPreview / VideoPlayer).
 * Usa `video.data` (no basta con que exista el objeto) y tipo de post en minúsculas.
 */
export function inferComposerHasVideo(
  video: PostVideo | null | undefined,
  selectedPost: SocialPost | null | undefined
): boolean {
  if (video?.data) return true;
  const raw = selectedPost?.post?.type;
  const t = typeof raw === "string" ? raw.toLowerCase() : "";
  return (
    t === SOCIAL_POST_TYPES.VIDEO && (selectedPost?.media?.length ?? 0) > 0
  );
}

/**
 * TikTok creator_info puede devolver booleanos como string/number.
 * `Boolean("false")` sería true en JS; esta función solo deshabilita con valores “afirmativos”.
 */
export function tiktokCreatorFlagDisablesFeature(value: unknown): boolean {
  if (value === true || value === 1) return true;
  if (typeof value === "string") {
    const s = value.trim().toLowerCase();
    return s === "true" || s === "1" || s === "yes";
  }
  return false;
}
